import { RootState } from '../store';

export const buyerSelector = (state: RootState) => state.buyer;
